import React, { Component } from 'react';
import PropTypes from 'prop-types';
import clonedeep from 'lodash.clonedeep';
import { connect } from 'react-redux';
import _get from 'lodash.get';
import { debugLogs, getQueryParams, modifyNestedObjects } from 'utils/common';

import {
  ETIMES_VIDEO_API_KEY,
  slikeVPEvents,
  TOI_VIDEO_API_KEY,
} from '../../constants';
import defaultObj from './defaults';
import { getPlaylistUrl } from './utils';
import './_base.scss';

const videoConfigkeys = ['config', 'playerEvents', 'adEvents'];

/**
 * Component to play video inside Slike v3 video player
 */
class VideoPlayer extends Component {
  constructor(props, defaultProps) {
    super(props, defaultProps);
    this.videoPlayerWrapper = React.createRef();
    this.videoPlayeInnerWrapper = React.createRef();
    this.currentPlayerInst = null;
    this.masterPlayerContainer = null;
    this.actualConfig = {};
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.SPL = window.SPL || {};
      window.SPL.config = {
        sdk: {
          apikey: this.props.apikey,
        },
      };
    }
  }

  componentDidMount() {
    this.loadVideo(this.videoPlayerWrapper);
    // if (
    //   this.props.manuallytriggerClick &&
    //   !document.body.classList.contains('videoplaying')
    // ) {
    //   this.videoPlayerWrapper.click();
    // }
    this.masterPlayerContainer = !this.masterPlayerContainer
      ? this.videoPlayeInnerWrapper
      : this.masterPlayerContainer;
  }

  /**
   * Loading video and default configurations
   * @param {*} videoWrapper : Dom element inside which video will be player
   */
  loadVideo(videoWrapper) {
    const _this = this;
    let defaultConfig = {};
    let _actualConfig = {};
    const { secid, requrl, url, msid, videoshowData } = this.props;
    let { slikeVideoId } = this.props;
    if (!slikeVideoId) {
      slikeVideoId = videoshowData?.slikeId;
    }
    if (defaultObj) {
      defaultConfig = clonedeep(defaultObj());
    }
    const isEmbed = parseInt(getQueryParams('embed', { href: url }), 10)
      ? 0
      : 1;
    const isEtimes = parseInt(getQueryParams('etimes', { href: url }), 10);
    let isSkipad = getQueryParams('skipad', { href: url });
    if (isEtimes === 1 && isEmbed === 0) {
      defaultConfig = modifyNestedObjects(
        defaultConfig,
        'apiKey',
        TOI_VIDEO_API_KEY,
        ETIMES_VIDEO_API_KEY,
      );

      const playerSubsec = getQueryParams('playersubsec', { href: url });
      const playlistUrl = `https://m.timesofindia.com/etvidepostroll_v7/${playerSubsec}.cms?feedtype=json&dontshow=${msid}&callback=cached`;

      defaultConfig = modifyNestedObjects(
        defaultConfig,
        'playlistUrl',
        '',
        playlistUrl,
      );
    } else if (isEmbed === 1) {
      defaultConfig = modifyNestedObjects(
        defaultConfig,
        'apiKey',
        TOI_VIDEO_API_KEY,
        'toiweba5ec9705eb7ac2c984033e061',
      );
      isSkipad = 'true';
    }

    const newConfig = defaultConfig.config;
    newConfig.callbacks = {
      canPlayNextVideo(videoData, callback) {
        if (videoData.msid) {
          window.top.location = videoData.msid.replace(
            '/videoshow/',
            '/amp_videoshow/',
          );
        } else {
          callback();
        }
      },
    };
    defaultConfig = modifyNestedObjects(defaultConfig, 'config', '', newConfig);
    _actualConfig = this.extendCustomConfig(defaultConfig);
    if (slikeVideoId && slikeVideoId !== '') {
      _actualConfig = this.setSlikeVideoId(_actualConfig);
    }
    if (secid && secid !== '' && isEtimes !== 1) {
      _actualConfig = this.setPlaylistUrl(_actualConfig);
    }
    this.setDescriptionUrl(_actualConfig, requrl);
    this.setDescriptionUrlPlayer(_actualConfig, requrl);
    this.setPagetpl(_actualConfig);
    this.setpageSection(_actualConfig, requrl);
    if (isSkipad && isSkipad === 'true') {
      this.setSkipAd(_actualConfig);
    }
    this.actualConfig = _actualConfig;
    _this.slikeVideoLoad(videoWrapper);
  }

  /**
   * Extend custom video player configuration over default configuration.
   * @param {*} defaults : Default configuration for video player
   */
  extendCustomConfig = defaults => {
    const _defaults = defaults;
    const { config } = this.props;
    videoConfigkeys.forEach(configKey => {
      Object.keys(_defaults[configKey]).forEach(prop => {
        if (config[configKey] && config[configKey][prop]) {
          if (
            typeof config[configKey][prop] === 'object' &&
            !Array.isArray(config[configKey][prop])
          ) {
            _defaults[configKey][prop] = {
              ..._defaults[configKey][prop],
              ...config[configKey][prop],
            };
          } else {
            _defaults[configKey][prop] = config[configKey][prop];
          }
        }
      });
    });
    return _defaults;
  };

  setSlikeVideoId = defaults => {
    const _defaults = defaults;
    let { slikeVideoId } = this.props;
    if (!slikeVideoId) {
      slikeVideoId = this.props.videoshowData?.slikeId;
    }
    if (_defaults && _defaults.config && _defaults.config.video) {
      _defaults.config.video.id = slikeVideoId;
    }
    return _defaults;
  };

  setPlaylistUrl = defaults => {
    const _defaults = defaults;
    const { secid, msid } = this.props;
    if (_defaults && _defaults.config && _defaults.config.player) {
      _defaults.config.player.playlistUrl = getPlaylistUrl({
        secid,
        msid,
        isProd: false,
      });
    }
    return _defaults;
  };

  setDescriptionUrl = (defaults, requrl) => {
    const _defaults = defaults;
    if (_defaults && _defaults.config && _defaults.config.video) {
      _defaults.config.video.description_url = requrl;
    }
    return _defaults;
  };

  setDescriptionUrlPlayer = (defaults, requrl) => {
    const _defaults = defaults;
    if (_defaults && _defaults.config && _defaults.config.player) {
      _defaults.config.player.description_url = requrl;
    }
    return _defaults;
  };

  setPagetpl = defaults => {
    const _defaults = defaults;
    if (_defaults && _defaults.config && _defaults.config.player) {
      _defaults.config.player.pagetpl = 'AMP Videoshow';
    }
    return _defaults;
  };

  setpageSection = (defaults, requrl) => {
    const _defaults = defaults;
    if (_defaults && _defaults.config && _defaults.config.player) {
      let urlPathArray =
        typeof requrl !== 'undefined' ? requrl?.split('.com')[1] : [];
      let pageSectionName = '';
      if (typeof urlPathArray !== 'undefined') {
        urlPathArray = urlPathArray.split('/');
        if (
          urlPathArray.length >= 4 &&
          urlPathArray[1] &&
          urlPathArray[2] &&
          urlPathArray[3].length <= 15
        ) {
          pageSectionName = `${urlPathArray[1]}/${urlPathArray[2]}/${
            urlPathArray[3]
          }`;
        } else if (
          urlPathArray.length >= 3 &&
          urlPathArray[1] &&
          urlPathArray[2]
        ) {
          pageSectionName = `${urlPathArray[1]}/${urlPathArray[2]}`;
        } else if (urlPathArray.length === 2 && urlPathArray[1]) {
          pageSectionName = `${urlPathArray[1]}`;
        } else if (
          requrl.split('.com')[1] === '/' ||
          requrl.split('.com')[1] === ''
        ) {
          pageSectionName = 'Home';
        }
        _defaults.config.player.pageSection = pageSectionName;
      }
    }
    return _defaults;
  };

  setSkipAd = defaults => {
    const _defaults = defaults;
    if (_defaults && _defaults.config && _defaults.config.player) {
      _defaults.config.player.skipAd = true;
    }
    return _defaults;
  };

  /**
   * Initialization logic before video plays
   * @param {*} config : Configuration for video player
   */
  initPlayer = config => {
    const { msid } = this.props;
    const { playerEvents } = this.actualConfig;
    this.currentPlayerInst = new window.SlikePlayer(config);

    if (typeof window !== 'undefined') {
      window.slikePlayerV3 = { playerVars: config };
      debugLogs(' Slikeplayer V3 Config : ', config);
      debugLogs(' Slikeplayer V3 instance : ', this.currentPlayerInst);
    }

    if (playerEvents && typeof playerEvents.onVideoRequest === 'function') {
      playerEvents.onVideoRequest({
        player: this.currentPlayerInst,
        eventName: 'VIDEOREQUEST',
        eventData: { msid },
      });
    }

    Object.keys(window.SlikePlayer.Events).forEach(eventKey => {
      const eventName = window.SlikePlayer.Events[eventKey];
      this.currentPlayerInst.on(
        eventName,
        this.mapEventWithFunc.bind(null, this.currentPlayerInst),
      );
    });
    Object.keys(window.SlikePlayer.AdEvents).forEach(eventKey => {
      const eventName = window.SlikePlayer.AdEvents[eventKey];
      this.currentPlayerInst.on(
        eventName,
        this.mapEventWithFunc.bind(null, this.currentPlayerInst),
      );
    });
  };

  /**
   * Maps event with callback functions
   * @param {*} player : Slike player
   * @param {*} eventName : Type of event
   * @param {*} data : Event data
   */
  mapEventWithFunc = (player, eventName, data) => {
    const { msid } = this.props;
    const { playerEvents, adEvents } = this.actualConfig;
    const funcName = slikeVPEvents[eventName];
    const eventData = data || {};
    if (!funcName) return;

    if (typeof playerEvents[funcName] === 'function') {
      playerEvents[funcName]({
        player,
        eventName,
        eventData: { ...eventData, msid },
      });
    } else if (typeof adEvents[funcName] === 'function') {
      adEvents[funcName]({
        player,
        eventName,
        eventData: { ...eventData, msid },
      });
    }
  };

  /**
   * Loading video in slike player
   * @param {*} videoWrapper : Dom element in which video will be played
   */
  slikeVideoLoad = videoWrapper => {
    const { wrapper, msid } = this.props;
    const { config, playerEvents } = this.actualConfig;
    this.videoWrapper = videoWrapper;

    if (
      typeof window.spl !== 'undefined' &&
      typeof window.spl.load === 'function'
    ) {
      window.playerConfig = config.video;
      config.contEl = wrapper;

      if (window.SlikePlayer) {
        this.initPlayer(config);
      } else {
        if (
          playerEvents &&
          typeof playerEvents.onVideoLoadRequest === 'function'
        ) {
          playerEvents.onVideoLoadRequest({
            player: {},
            eventName: 'VIDEOLOADREQUEST',
            eventData: { msid },
          });
        }
        window.spl.load(config, sdkLoadStatus => {
          if (sdkLoadStatus) {
            this.initPlayer(config);
          }
        });
      }
    }
  };

  render() {
    const { wrapperHeight } = this.props;
    const _style = { height: wrapperHeight };
    return (
      <React.Fragment>
        <div
          className="default-outer-player"
          ref={el => {
            this.videoPlayerWrapper = el;
          }}
        >
          <div
            className="default-player master-player-container"
            id="masterVideoPlayer"
            style={_style}
            ref={el => {
              this.videoPlayeInnerWrapper = el;
            }}
          />
        </div>
      </React.Fragment>
    );
  }
}

VideoPlayer.defaultProps = {
  wrapperHeight: '',
  requrl: '',
  videoshowData: {},
};

VideoPlayer.propTypes = {
  apikey: PropTypes.string.isRequired,
  config: PropTypes.shape({}).isRequired,
  wrapper: PropTypes.string.isRequired,
  slikeVideoId: PropTypes.string.isRequired,
  msid: PropTypes.string.isRequired,
  secid: PropTypes.string.isRequired,
  requrl: PropTypes.string,
  wrapperHeight: PropTypes.string,
  videoshowData: PropTypes.shape({}),
};

const mapStateToProps = state => ({
  videoshowData: _get(state, 'videoshow.videoData'),
});

export default connect(mapStateToProps)(VideoPlayer);
